import { useEffect, useState } from "react";
import useApiHelper from "../../hooks/useApiHelper";
import Card from "../shared/Card/Card";
import DashboardStat from "../dashboard/DashboardStat";
import OrderStatsTable from "./OrderStatsTable";
import apiConfig from "../../utils/apiConfig";

export interface IUserPartDataStats {
  userId             : string;
  userFullName       : string;
  dispatched         : number;
  dailyAvgDispatched : number;
  picked             : number;
  dailyAvgPicked     : number;
  packed             : number;
  dailyAvgPacked     : number;
  returnsRate        : number;
  missingRate        : number;
}

export default function EbayOrdersStats({pageMode} : {pageMode?: number} ) {
  const { post } = useApiHelper(apiConfig("EbayOrdersStats"));

  const [providers, setProviders] = useState<Record<string, number>>({} as Record<string, number>);

  const [awaitingPicking  , setAwaitingPicking  ] = useState<number>(0);
  const [awaitingPacking  , setAwaitingPacking  ] = useState<number>(0);
  const [awaitingDispatch , setAwaitingDispatch ] = useState<number>(0);
  const [newInToday       , setNewInToday       ] = useState<number>(0);
  const [dispatchedToday  , setDispatchedToday  ] = useState<number>(0);
  const [overdue          , setOverdue          ] = useState<number>(0);
  const [userStats        , setUserStats        ] = useState<IUserPartDataStats[]>([]);

  useEffect(() => {
    post(`/part/orders/stats`, {}).then((response) => {
      if (response?.data) {
        var data = response.data || {};

        console.log("Stats data", response.data);

        setAwaitingPicking(data.awaitingPicking || 0);
        setAwaitingPacking(data.awaitingPacking || 0);
        setAwaitingDispatch(data.awaitingDispatch || 0);
        setNewInToday(data.newInToday || 0);
        setDispatchedToday(data.dispatchedToday || 0);
        setOverdue(data.overdue || 0);
        setProviders(data.shippingStats);
        setUserStats(data.userStats || []);
      }
    });
  }, []);

  useEffect(() => {
    console.log("Providers", providers);
  }, [providers]);

  return (
    <Card bodyClassName="p-4 grid grid-cols-1 lg:grid-cols-3 gap-4" title="Order Stats" collapsible >

      {/* General Stats */}

      <div className="grid gap-2 grid-cols-1 lg:grid-cols-2">

        <div className="row-span-2 h-full rounded bg-teal-100 text-teal-600 p-2 px-4 prose-base">
          <h1 className="mb-1 font-semibold text-2xl">Shipping</h1>
          <ul className="p-0 text-sm">
            {Object.entries(providers).map(([name, count], i) => (
              <li key={i} className="!m-0">
                {name}:{" "}
                {
                  count
                }
              </li>
            ))}
          </ul>
        </div>

        <DashboardStat title={awaitingPicking.toString()} desc={"Awaiting Picking"} color={"blue"} />
        <DashboardStat title={awaitingPacking.toString()} desc={"Awaiting Packing"} color={"pink"} />
        <DashboardStat title={awaitingDispatch.toString()} desc={"Awaiting Dispatch"} color={"green"} />
        <DashboardStat title={newInToday.toString()} desc={"New in Today"} color={"amber"} />
        <DashboardStat title={dispatchedToday.toString()} desc={"Dispatched Today"} color={"purple"} />
        <DashboardStat title={overdue.toString()} desc={"Overdue"} small="Of Priced Parts" color={"rose"} />

      </div>

      {/* User Stats */}

      <div className="flex flex-col gap-2 lg:col-span-2">

        {/* <UnlistedStatsTable unlistedStats={stats} /> */}
        <OrderStatsTable orderStats={userStats} />

      </div>

    </Card>
  )
}